import styled from 'styled-components';

export const Container = styled.div`
  border: 1px dashed ${(props) => props.theme.$gray400};
  font-size: 13px;
  line-height: 1.4;

  .team-chip {
    display: inline-block;
    font-size: 12px;
  }

  .team-link {
    font-size: 12px;
    white-space: normal;
    line-height: 1.4;
  }
`;
